/**
 * Created by Mark on 06/04/2017.
 */

import React  from 'react';
import DataTableComponent from './table.component.js';
import { FormattedMessage } from 'react-intl';
import ClassService from '../../services/classes-service.js';
import ClassesStore from '../../store/classes-store.js';

export default class ClassesTableComponent extends React.Component {

    constructor(props){
        super();

        this.state = {
             type: props.type || 'selector',
             additionalButtons: props.additionalButtons || [],
             enableActions: props.enableActions,
             classes:[],
        }

    }

    componentDidMount() {
        ClassService.getViewableClasses();
    }

    componentWillMount(){
        ClassesStore.on("CHANGE" , () => {
            this.setState({
                classes:ClassesStore.classes
            });
        });
    }

    rebuildSchema() {

        let dataObject = this.state.classes;

        const schema = {
            type: 'object',
            properties: {
                className: {
                    type: 'link',
                    translationsID: "ui-452",
                    display: true,
                    defaultMessage: 'Class Name',
                    id: 'profileLink'
                },
                totalStudents: {
                    type: 'link',
                    translationsID: "ui-857",
                    modifable: false,
                    display: true,
                    defaultMessage: 'Students',
                    className:'hidden-xs',
                    id: 'totalStudentsLink'
                },
                words: {
                    type: 'string',
                    translationsID: "ui-2159",
                    modifable: false,
                    display: true,
                    defaultMessage: 'Words',
                    id: 'words'
                },
            },
            data: dataObject
        };

        return schema;
    }

    render(){
        return <DataTableComponent enableActions={this.state.enableActions} additionalButtons={this.state.additionalButtons} type={this.state.type} schema={this.rebuildSchema([])} ref={(object) => { this.table = object; } }  />
    }
}


// WEBPACK FOOTER //
// ./src/components/tables/classes-table.js